import { createAction } from '@ngrx/store';

const cacheCleared = createAction('[Cache Manager] The cache was cleared');

export const CacheManagerActions = {
  cacheCleared,
};
